var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getPercentageDiff } from '@workalizer/shared/utils';
var partnerMetric = function (current, previous) {
    return getPercentageDiff(previous, current);
};
var buildPartner = function (partner) {
    var prevMeetings = partner.prevMeetings, prevDocuments = partner.prevDocuments, prevChats = partner.prevChats, prevGmails = partner.prevGmails, rest = __rest(partner, ["prevMeetings", "prevDocuments", "prevChats", "prevGmails"]);
    return __assign(__assign({}, rest), { meetingsDiff: partnerMetric(partner.meetings.count, prevMeetings), documentsDiff: partnerMetric(partner.documents, prevDocuments), chatsDiff: partnerMetric(partner.chats, prevChats), gmailsDiff: partnerMetric(partner.gmails, prevGmails) });
};
export var mostFrequentCommunicationPartners = function (_input) {
    return [
        buildPartner({
            name: 'John Smith',
            orgUnitName: 'Engineering',
            partnerUserId: 1,
            meetings: { count: 8, duration: '4h 30m' },
            documents: 12,
            chats: 25,
            gmails: 18,
            prevMeetings: 5,
            prevDocuments: 8,
            prevChats: 20,
            prevGmails: 15
        }),
        buildPartner({
            name: 'Sarah Johnson',
            isManager: true,
            orgUnitName: 'Product',
            partnerUserId: 2,
            meetings: { count: 6, duration: '3h 15m' },
            documents: 8,
            chats: 18,
            gmails: 14,
            prevMeetings: 5,
            prevDocuments: 6,
            prevChats: 16,
            prevGmails: 12
        }),
        buildPartner({
            name: 'Mike Wilson',
            orgUnitName: 'Design',
            partnerUserId: 3,
            meetings: { count: 5, duration: '2h 45m' },
            documents: 6,
            chats: 15,
            gmails: 11,
            prevMeetings: 4,
            prevDocuments: 5,
            prevChats: 14,
            prevGmails: 10
        }),
        buildPartner({
            name: 'Emily Davis',
            orgUnitName: 'Marketing',
            partnerUserId: 4,
            meetings: { count: 4, duration: '2h 10m' },
            documents: 5,
            chats: 12,
            gmails: 9,
            prevMeetings: 3,
            prevDocuments: 4,
            prevChats: 11,
            prevGmails: 8
        }),
        buildPartner({
            name: 'David Brown',
            orgUnitName: 'Sales',
            partnerUserId: 5,
            meetings: { count: 3, duration: '1h 45m' },
            documents: 4,
            chats: 10,
            gmails: 7,
            prevMeetings: 2,
            prevDocuments: 2,
            prevChats: 9,
            prevGmails: 6
        })
    ];
};
